enum AddressVersionEnum {
    GNAF_V1= 'GNAF_V1',
    V1 = 'V1',
    V2 = 'V2',
}

export default AddressVersionEnum;